/* 布局 */
//前台
import Layout from "@views/layout";

const schcoursewareRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "schcourseware/list",
        name: "SCHCOURSEWARE",
        meta: {
            title: "学校课件库",
        },
        component: () => import("@views/business/schcourseware/index.vue"),
    },
        ],
};

export default schcoursewareRouter;
